import { useRef } from "react";
export const FileUploader = ({ handleFile }) => {
  // Create a reference to the hidden file input element
  const hiddenFileInput = useRef(null);

  // Programatically click the hidden file input element
  // when the Button component is clicked
  const handleClick = (event) => {
    event.preventDefault();
    hiddenFileInput.current.click();
  };
  // Call a function (passed as a prop from the parent component)
  // to handle the user-selected file
  const handleChange = (event) => {
    if (event.target.files[0]?.size > 1048576 * 5) {
      // const fileUploaded = event.target.files[0];
      handleFile(false);
    } else {
      const fileUploaded = event.target.files;
      handleFile(fileUploaded);
    }
    event.target.value = "";
  };
  return (
    <>
      <button className="btn-uploader" onClick={handleClick}>
        <i className="fa fa-upload"></i>&nbsp;Select Files &nbsp;<span className="required">*</span>&nbsp;
      </button>
      <input
        type="file"
        multiple={true}
        accept="application/pdf, application/msword,image/*"
        onChange={handleChange}
        ref={hiddenFileInput}
        style={{ display: "none" }} // Make the file input element invisible
      />
    </>
  );
};

export default FileUploader;
